import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box, InputLabel, Select,
  FormControl, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { useLocation } from 'react-router-dom';


import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';

const baseUrl=process.env.REACT_APP_API_BASE_URL
function OrgDashPaidBusFee() {
  const {oId,role,userId,pId}=useAuth();
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [selectedBus, setSelectedBus] = useState("");
  const [busData, setBusData] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dateRangeFromQuery = queryParams.get('dateRange');

   const [dialogOpen, setDialogOpen] = useState(false);
   const [selectedRowData, setSelectedRowData] = useState(null);
   const [selectedadmissionNo, setselectedAdmissionNo] = useState(null);

   const [dialogTableloading, setDialogTableloading] = useState(true);
   const [dialogTableData, setDialogTableData] = useState(null);

  

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
 
  

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  console.log("Selected User:",UserId);




 
//     const fetchUsers = async () => {
//         try {
//             const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch users');
//             }
//             const data = await response.json();
//             setUsers(data);
//             if (data.length > 0) {
//               setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
//           }
//         } catch (error) {
//             console.error('Error fetching users:', error);
//         }
//     };
// useEffect(() => {
//   if (isPrincipal) {
//     fetchUsers();
//   }
// }, []); // ✅ Only runs on mount 

   const [transportusers, settransportUsers] = useState([]);
  const [selectedTransportUsers, setSelectedTransportUsers] = useState('');

  
//     const fetchTransportUsers = async () => {
//         try {
//             const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
//             if (!response.ok) {
//                 throw new Error('Failed to fetch users');
//             }
//             const data = await response.json();
//             settransportUsers(data);
//             if (data.length > 0) {
//               setSelectedTransportUsers(data[0].userId); // ✅ Set first record's userId as default
//           }
//         } catch (error) {
//             console.error('Error fetching users:', error);
//         }
//     };

// useEffect(() => {
 
//     fetchTransportUsers();

// }, [oId,pId]); // ✅ Only runs on mount 






 const handleViewClick = (row) => {
   setSelectedRowData(row); // Set the selected row's data
   setselectedAdmissionNo(row.admissionNumber)
   setDialogOpen(true); // Open the dialog
 };

 const handleCloseDialog = () => {
   setDialogOpen(false); // Close the dialog
 };

//DIALOG TABLE DATA
 useEffect(() => {
  const fetchDialogTableData = async () => {
    if (!selectedadmissionNo) return; // Prevent API call if no admission number is selected

    setDialogTableloading(true);
    try {
      const response = await fetch(`${baseUrl}/api/transaction/getAllTransaction/${selectedadmissionNo}/${oId}/bus_fee`);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      console.log("Fetched Data:", data);
      setDialogTableData(data || []); // Ensure it's always an array

    } catch (error) {
      console.error("Error fetching Bus Numbers:", error);
      setDialogTableData([]); // Ensure state remains consistent
    } finally {
      setDialogTableloading(false); // Set loading to false after fetching
    }
  };

  fetchDialogTableData();
}, [selectedadmissionNo, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes

//BUS NUMBERS DATA
  useEffect(() => {
    const fetchData = async () => {
     
      try {
        const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers-org/${oId}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setBusData(data); // Assuming 'data' is an array of bus numbers
        if (data.length > 0) {
          setSelectedBus(data[0]); // Set the first item as default
        }
      } catch (error) {
        
        console.error("Error fetching Bus Numbers:", error);
      } 
    };

    fetchData();
  }, []);


  //TABLE DATA FETCH API
    // const fetchBusFeeDetails = async () => {
    //   setLoading(true); // Set loading to true before fetching data
    //     try {
    //       const response = await fetch(
    //         `${baseUrl}/api/busFee/getAllStudentTransactionsOnlyPaid/${oId}?busNumber=${selectedBus}&rolePayment=bus_fee`
    //       );
  
    //       if (!response.ok) {
    //         throw new Error("Failed to fetch transactions");
    //       }
  
    //       const data = await response.json();
    //       // setFilteredData(data);
    //       setFilteredData(data || []); // Ensure it handles the correct response format
  
    //     } catch (err) {
    //       console.error("Error fetching transactions:", err);
    //     }finally {
    //       setLoading(false); // Set loading to false after fetching (whether success or error)
    //     }

    //   };
    // useEffect(() => {
    //   fetchBusFeeDetails();
    // }, [selectedBus]);



const fetchPaidBusFeesList = async () => {

  setLoading(true); // Set loading to true before fetching data
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    
    if (!selectedBus) return;

    switch (dateRangeFromQuery) { // ✅ Changed to 'dateRange'
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getTodayBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getYesterDayBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getLastWeekBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getThisMonthBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getLastSixMonthsBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
      case "currentAcademicYear":
          endpoint = `${baseUrl}/api/admissionFeeDashBoard/getCurrentAcademicYearBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
          break;
      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/getCurrentAcademicYearBusTransaction/${formattedDate}/bus_fee/${oId}/${selectedBus}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    setFilteredData(data || []);
    
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
    setFilteredData([]); // Ensure table does not break on error
  }finally {
    setLoading(false); // Set loading to false after fetching (whether success or error)
  }
};

useEffect(() => {
  fetchPaidBusFeesList();
}, [selectedBus]); 




    







 // Filter data based on searchQuery
 const filteredResults = filteredData.filter((item) => {
  const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
  const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
  const fullName = `${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
  const admissionNumber = item.customAdmissionNumber ? item.customAdmissionNumber.toString() : ""; // Ensure it's a string

  return (
    fullName.includes(searchQuery.toLowerCase()) || // Search in full name
    admissionNumber.includes(searchQuery) // Search in admission number
  );
});





// Export to Excel
const exportToExcel = () => {
  const filteredData = filteredResults.map(({ 
    customAdmissionNumber, studentFirstName, studentLastName, 
    gender, busNumber, routeNumber, fatherPhoneNumber, 
    grandTotal, totalPaid
  }) => ({
    AdmissionNumber: customAdmissionNumber,  
    StudentName: `${studentFirstName} ${studentLastName}`,
    Gender: gender,
    BusNumber: busNumber,
    Route: routeNumber,
    Phone: fatherPhoneNumber,
    TotalFee: grandTotal,
    PaidAmount: totalPaid,
  }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList`);

  // Add headers
  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Bus No", key: "BusNumber", width: 10 },
    { header: "Route", key: "Route", width: 10 },
    { header: "Phone", key: "Phone", width: 15 },
    { header: "Total Fee", key: "TotalFee", width: 15 },
    { header: "Paid Amount", key: "PaidAmount", width: 15 },
  ];

  // Add data rows and style the "Paid Amount" column in green
  filteredData.forEach((data) => {
    const row = worksheet.addRow(data);
    const paidAmountCell = row.getCell("PaidAmount");

    // Apply green text color to the "Paid Amount" column
    paidAmountCell.font = { color: { argb: "008000" }, bold: true }; // Green and bold
  });

  // Style headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light blue header
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList.xlsx`;
    link.click();
  });

  handleExportClose();
};

// Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_Paid Bus Fee List`, 10, 8);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Table
  doc.autoTable({
    startY: 20,
    head: [["S.No", "Admission No", "Student Name", "Gender", "Bus No", "Route", "Phone", "Total Amount", "Paid Amount"]],
    body: filteredResults.map((row, index) => [
      index + 1,
      row.customAdmissionNumber,
      `${row.studentFirstName} ${row.studentLastName}`,
      row.gender,
      row.busNumber,
      row.routeNumber,
      row.fatherPhoneNumber,
      row.grandTotal,
      { content: row.totalPaid, styles: { textColor: [0, 128, 0], fontStyle: "bold" } }, // Green color for Paid Amount
    ]),
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  doc.save(`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_Paid BusFeeList.pdf`);
  handleExportClose();
};


// Export to JSON
const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredResults, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''}-${selectedBus}_PaidBusFeeList.json`;
  link.click();
  handleExportClose();
};

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent
        // style={{
        //   maxWidth: "950px",
        //   margin: "auto",
        // }}
      >
        {/* Title Section */}
        {/* <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Paid Bus Details
            </Typography>
          </Grid>
          
        </Grid> */}
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              {`${dateRangeFromQuery ? dateRangeFromQuery.charAt(0).toUpperCase() + dateRangeFromQuery.slice(1) : ''} Paid Bus Fee Details`}
                              </Typography>
                            </Box>

     {/* Search and Add New Button Section */}
     <Grid
  container
  spacing={2}
  alignItems="center"
  justifyContent="space-between"
  style={{ marginTop: "1px" }}
>
  {/* Left Side - Search & Select */}
  <Grid item xs={6} style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <TextField
         label="Search by Admission No or Name"
         variant="outlined"
         size="small"
         style={{width:'250px'}}
         value={searchQuery}
         onChange={(e) => setSearchQuery(e.target.value)}
         fullWidth
       />
   
   <FormControl style={{ width: "200px" }} variant="outlined" size="small">
           <InputLabel id="bus-select-label" style={{ fontSize: "12px" }}>
             Select Bus
           </InputLabel>
           <Select
             labelId="bus-select-label"
             value={selectedBus}
             onChange={(e) => setSelectedBus(e.target.value)}
             label="Select Bus"
             style={{ height: "35px", fontSize: "12px" }}
           >
             {busData.map((bus, index) => (
               <MenuItem key={index} value={bus}>
                 {bus}
               </MenuItem>
             ))}
           </Select>
         </FormControl>

          {/* <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
                  <InputLabel>Select Transport Admin</InputLabel>
                  <Select
                    value={selectedTransportUsers}
                    onChange={(e) => setSelectedTransportUsers(e.target.value)}
                    label="Select Admin"
                  >
                    {transportusers.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user.userId}-{user.firstName} {user.lastName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}

    {/* {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}
  </Grid>

  {/* Right Side - Button */}

  <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" }}>
  <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
    startIcon={<PresentToAllIcon />}  
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem>
  </Menu>
</Grid>






</Grid>


<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Admission No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Date
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Gender
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Bus No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Route
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Pickup
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Drop
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',fontSize:'14px'
                  }}
                >
                  Paid Amount
                </TableCell>
                 <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Payment Details </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                   <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                      <CircularProgress />
                                                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                                                        Loading Data...
                                                                      </Typography>
                                                                    </Box>
                                                                  </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow key={row.id} style={{
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    height: "40px",  // Reduced row height
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white"; // Default color
                  }}>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                      
                    >
                      {index + 1}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Avatar
                          src={row.photo}
                          alt={row.name}
                          sx={{ width: 30, height: 30, marginRight: 1 }}
                        />
                        <Typography variant="body2" color="textSecondary">
                          {row.id}
                        </Typography>
                      </Box>
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.customAdmissionNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.paymentDate}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentFirstName} {row.studentLastName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.gender}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.routeNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentPickupLocation}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.studentDropLocation}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.fatherPhoneNumber}
                    </TableCell>
                    <TableCell
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
   
  }}
>
  <Button
    style={{
      backgroundColor: "#65C63E",
      color: "#fff",
      fontWeight: "bold",
      textTransform: "none",
      borderRadius: "20px",
    }}
  >
    ₹{row.totalPaid}
  </Button>
</TableCell>
<TableCell
              sx={{
                borderLeft: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              <Button
                type="button"
                onClick={() => handleViewClick(row)} // Open dialog with the row data
                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  fontSize: "0.6rem", // Reduces the font size
                  height: "25px", // Reduces the height
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                }}
              >
                View
              </Button>
            </TableCell>

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="sm" sx={{ borderRadius: 3 }}>
  <DialogTitle 
    sx={{ 
      fontWeight: "bold", 
      textAlign: "center", 
      bgcolor: "#1976d2", 
      color: "white",
      py: 2,
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3
    }}
  >
    Paid Bus Fee Payment Details
  </DialogTitle>
  <DialogContent>
    {selectedRowData && (
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "column",
          marginTop:"20px" ,
          gap: 2, 
          p: "20px 20px 20px 20px",
          bgcolor: "#f5f5f5", 
          borderRadius: 2 
        }}
      >
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Student Name: 
          <span style={{ fontWeight: "normal", color: "#2e7d32" , fontWeight: "bold"}}>{selectedRowData.studentFirstName} {selectedRowData.studentLastName}</span>
        </Typography>
       
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Total Amount: 
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>₹{selectedRowData.grandTotal}</span>
        </Typography>
        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
        {`${
              dateRangeFromQuery
                ? dateRangeFromQuery.charAt(0).toUpperCase() +
                  dateRangeFromQuery.slice(1)
                : ""
            } Paid Amount:`}
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>₹{selectedRowData.totalPaid}</span>
        </Typography>
        {/* <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#333" }}>
          Status: 
          <span style={{ fontWeight: "normal", color: "#2e7d32", fontWeight: "bold" }}>Bus Fee Cleared</span>
        </Typography> */}

 {/* Transactions Toggle Section */}
 <Box 
              sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                cursor: "pointer",
                fontWeight: "bold",
                color: "#1976d2",
                "&:hover": { textDecoration: "underline" }
              }} 
              onClick={() => setShowTransactions(!showTransactions)}
            >
              <Typography variant="h6"> Show Transactions</Typography>
              <Typography variant="h6">{showTransactions ? "▲" : "▼"}</Typography>
            </Box>

            {/* Transaction Table - Conditional Rendering */}
            {showTransactions && (
              <TableContainer component={Paper} sx={{ mt: 2, maxHeight: "100px", overflowY: "auto",}} className="custom-sidebar-scrollbar">
                <Table stickyHeader>
                  <TableHead sx={{ bgcolor: "#1976d2" }} >
                    <TableRow>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Sl No</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Payment Date</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Amount Paid</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Transaction ID</TableCell>
                      <TableCell  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                  }}>Payment Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {dialogTableloading ? (
                <TableRow>
                   <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                      <CircularProgress />
                                                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                                                        Loading Data...
                                                                      </Typography>
                                                                    </Box>
                                                                  </TableCell>
                </TableRow>
              ) : dialogTableData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                dialogTableData.map((transaction, index) => (
                      <TableRow key={transaction.transactionId}>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{index + 1}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.paymentDate}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>₹{transaction.paymentAmount}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.transactionId || "N/A"}</TableCell>
                        <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd", padding: "2px", }}>{transaction.payMethod}</TableCell>
                      </TableRow>
                    ))
                  )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
    )}
  </DialogContent>
  <DialogActions sx={{ justifyContent: "flex-end", pt: 0.5,pb: 1, pr: 2 }}>
  <Button 
    onClick={handleCloseDialog} 
    variant="contained" 
    sx={{ 
      fontSize: "0.8rem", // Slightly smaller font size
      // px: 3, 
      // py: 0.5, // Reduced height
      // borderRadius: 2, 
      bgcolor: "#3C3972", // Elegant blue color
      color: "white",
      "&:hover": { bgcolor: "#3C3972" } 
    }}
  >
    Close
  </Button>
</DialogActions>

</Dialog>
      </CardContent>
    </Card>
  );
}

export default OrgDashPaidBusFee;